<!-- eslint-disable @angular-eslint/template/alt-text -->
<div
    class="agpr-browseImage {{mainClass}} {{borderClass}} agpr-contextMenu-parent"
    [style.width]="placeholderWidth ? placeholderWidth + 'px' : null"
    [style.height]="placeholderHeight ? placeholderHeight + 'px' : null"
    *ngIf="showPlaceholder"
>
    <input
        type="file"
        #fileCtrl
        id="agpr-browseImage-dummyFileInput-{{id}}"
        class="agpr-browseImage-fileInput"
        accept="image/*"
        [disabled]="isDisabled"
        (change)="handleFileInput($event.target.files[0], fileCtrl)"
        (click)="resetInputValue(fileCtrl)"
        [attr.title]="filename"
        tabindex="-1"
    />

    <ul role="group" [attr.aria-label]="ariaLabel + ' Image Block'">
        <ul
            *ngIf="showMoveButtons && !isDisabled"
            class="agpr-contextMenu top left"
            role="menu"
            aria-label="Move Block"
        >
            <li role="menuitem" *ngIf="!moveUpDisabled">
                <agpr-button
                    icon="fa-regular fa-arrow-up"
                    class="agpr-browseImage-iconButton"
                    (click)="onMoveUp()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.moveUp'"
                    [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
            </li>
            <li role="menuitem" *ngIf="!moveDownDisabled">
                <agpr-button
                    icon="fa-regular fa-arrow-down"
                    class="agpr-browseImage-iconButton"
                    (click)="onMoveDown()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.moveDown'"
                    [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
            </li>
        </ul>
        <ul
            *ngIf="showDeleteButton && !isDisabled"
            role="menu"
            class="agpr-contextMenu top right"
            aria-label="Edit Block"
        >
            <li role="menuitem">
                <agpr-button
                    icon="fa-regular fa-duotone fa-trash-can"
                    class="agpr-browseImage-iconButton"
                    (click)="onImageDelete()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.delete'"
                    [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    icon="fa-regular fa-duotone fa-pen"
                    class="agpr-browseImage-iconButton"
                    (click)="fileCtrl.click()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.edit'"
                    [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
            </li>
        </ul>
    </ul>

    <label
        for="agpr-browseImage-fileInput-{{id}}"
        [ngClass]="showImageHtml ? 'agpr-browseImage-show':'agpr-browseImage-hide'"
    >
        <img
            class="{{!isDisabled ?'agpr-browseImage-placeholder imageClass':'agpr-browseImage-placeholder imageClass'}}"
            [src]="imageUrl != null && imageUrl != '' ? convertBase64ToImage(imageUrl) : getImageUrlBasedOnImageID(imageId)"
        />
    </label>
    <div
        class="agpr-browseImage-editableBlock {{ placeholderClass }}"
        [ngClass]="[showImageInput ? 'agpr-browseImage-show agpr-browseImage-placeholderText':'agpr-browseImage-hide']"
        [style.width]="placeholderWidth ? placeholderWidth + 'px' : null"
        [style.height]="placeholderHeight ? placeholderHeight + 'px' : null"
    >
        <div *ngIf="!isContact">
            <span class="agpr-browseImage-imageIcon {{ imageIcon }}">
            </span>
            <span class="agpr-browseImage-imageIconText">
            {{ placeholderName }}
            </span>
        </div>
        <div
            *ngIf="isContact"
            class="agpr-browseImage-uploadContactBtnWrapper"
        >
            <img src="/app/assets/images/userimg.jpg" width="70" height="70"/>
        </div>
    </div>
</div>
